<script setup lang="ts">
  import { computed } from 'vue'

  interface Props {
    documentUrl: string
    height?: string
  }

  const props = withDefaults(defineProps<Props>(), {
    height: '100%'
  })

  // Microsoft Office Online Viewer URL
  const viewerUrl = computed(() => {
    // Encode the document URL
    const encodedUrl = encodeURIComponent(props.documentUrl)
    return `https://view.officeapps.live.com/op/embed.aspx?src=${encodedUrl}`
  })

  const viewerStyle = computed(() => ({
    '--viewer-height': props.height
  }))
</script>

<template>
  <div
    class="microsoft-office-viewer"
    :style="viewerStyle"
  >
    <iframe
      :src="viewerUrl"
      class="office-iframe"
      frameborder="0"
    >
      This is an embedded Microsoft Office document, powered by Office.
    </iframe>
  </div>
</template>

<style scoped>
  .microsoft-office-viewer {
    width: 100%;
    height: var(--viewer-height, 100%);
    overflow: hidden;
    background: #ffffff;
    position: relative;
  }

  .office-iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
</style>
